import type { ApiClient } from "@/lib/api";

export const deleteOAuthProvider = async (options: {
  client: ApiClient;
  oauthId: string;
}) => {
  const { client, oauthId } = options;
  const { data } = await client.delete(`/auth_providers/${oauthId}`);
  return data;
};
